import { render, staticRenderFns } from "./CustomCheckboxComponent.vue?vue&type=template&id=4c840a6e"
import script from "./CustomCheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports